import { DecrementStencilOp, DecrementWrapStencilOp, IncrementStencilOp, IncrementWrapStencilOp, InvertStencilOp, KeepStencilOp, ReplaceStencilOp, ZeroStencilOp } from 'three';

export const stencilOpValues = {
    ZeroStencilOp,
    KeepStencilOp,
    ReplaceStencilOp,
    IncrementStencilOp,
    DecrementStencilOp,
    IncrementWrapStencilOp,
    DecrementWrapStencilOp,
    InvertStencilOp,
};

export const stencilOpNames: { [v: number]: StencilOp } = {};
Object.keys(stencilOpValues).forEach((k: StencilOp) =>
{
    stencilOpNames[stencilOpValues[k]] = k;
});

export type StencilOp = keyof typeof stencilOpValues;
